import React, { useState } from "react";
import { useSelector, shallowEqual } from "react-redux";
import { Card, CardBody, CardHeader, CardHeaderToolbar } from "../../../_metronic/_partials/controls";
import * as apiRag from "../../api/rag";

export function QueryPage() {
  const [loading, setLoading] = useState(false);
  const [question, setQuestion] = useState("");
  const [answer, setAnswer] = useState(null);
  const [error, setError] = useState(null);

  const user = useSelector((state) => state.auth.user, shallowEqual);

  const handleQuery = async (e) => {
    e.preventDefault();
    if (!question.trim()) return;

    setLoading(true);
    setAnswer(null);
    setError(null);
    try {
      const response = await apiRag.queryEvents(user.authToken, question);
      setAnswer(response.answer || response); // Handle structure depending on PHP return
    } catch (err) {
      setError(err.message || "Errore durante la ricerca");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Card>
      <CardHeader title="Ricerca Semantica Eventi (RAG)">
        <CardHeaderToolbar>
        </CardHeaderToolbar>
      </CardHeader>
      <CardBody>
        <div className="row">
          <div className="col-lg-12">
            <form onSubmit={handleQuery}>
              <div className="form-group">
                <label>Fai una domanda sui tuoi appuntamenti del 2026</label>
                <div className="input-group">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Es: Quali appuntamenti ho a Marzo?"
                    value={question}
                    onChange={(e) => setQuestion(e.target.value)}
                    disabled={loading}
                  />
                  <div className="input-group-append">
                    <button 
                      className="btn btn-primary" 
                      type="submit"
                      disabled={loading || !question.trim()}
                    >
                      {loading ? "Ricerca in corso..." : "Cerca"}
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>

        {answer && (
          <div className="card card-custom gutter-b bg-light-primary mt-4">
            <div className="card-body">
              <h4 className="text-primary mb-4">Risposta AI</h4>
              <div className="font-size-lg text-dark-75">
                {typeof answer === 'string' ? answer : JSON.stringify(answer, null, 2)}
              </div>
            </div>
          </div>
        )}

        {error && (
          <div className="alert alert-danger mt-4">
            <h4 className="alert-heading">Errore</h4>
            <p>{error}</p>
          </div>
        )}
      </CardBody>
    </Card>
  );
}
